import { T_LANDING_PAGE_CONSTANTS } from './TYPES'

const HU_LANDING_PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS = {
  PAGE_KICKER: 'Könyv. Kvíz. Közösség.',
  PAGE_TITLE: 'Egy kvízkönyvtár, ahol az olvasás és a játék összekapcsolódik.',
  PAGE_DESCRIPTION:
    'A gyerekek offline olvasnak könyveket, majd rövid, a szöveg megértését tesztelő kvízeket töltenek ki. Közben pontokat gyűjtenek, fejlesztik Griffyt, a griffmadarukat, és olvasáskihívásokhoz is csatlakozhatnak.',
  GET_STARTED_CTA_TEXT: 'Ingyenes fiók létrehozása',
  CARD_1_TITLE: 'Olvass el egy könyvet',
  CARD_1_DESCRIPTION: 'Olvass el egy könyvet – nincs szükség a képernyőre.',
  CARD_2_TITLE: 'Válaszolj a kvízre',
  CARD_2_DESCRIPTION: 'Válj értő olvasóvá és légy egy olvasó közösség része.',
  CARD_3_TITLE: 'Szerezz jutalmakat',
  CARD_3_DESCRIPTION: 'Gyűjts pontokat, jelvényeket és neveld Griffy-det.',
  FEATURES_KICKER: 'MI AZ A GRIFFYREADS? ITT TALÁLSZ INFÓT',
  FEATURES_TITLE: 'A GriffyReadsről',
  FEATURES_CHILD_LABEL: 'GYEREKEKNEK',
  FEATURES_ADULT_LABEL: 'FELNŐTTEKNEK',
  FEATURES_ENHANCE_READING_TITLE: [
    { label: 'Kezdj bele az' },
    {
      label: 'olvasáskalandba!',
      color: true,
      newLine: true
    }
  ],
  FEATURES_ENHANCE_READING_DESCRIPTION:
    'Olvass könyveket offline és vegyél részt izgalmas kihívásokban különböző műfajokban! A napi olvasás fejleszti a szókincsedet, a kommunikációs készségeidet, növeli a kreativitást és az empátiát, mindeközben szórakoztatóvá és jutalmazóvá téve a tanulást.',
  FEATURES_UNLOCK_AVATARS_TITLE: [
    { label: 'Válaszolj kvízekre, gyűjts pontokat és' },
    {
      label: 'neveld Griffydet!',
      color: true
    }
  ],
  FEATURES_UNLOCK_AVATARS_DESCRIPTION:
    'Teszteld a tudásodat szórakoztató kvízekkel és gyűjts pontokat minden helyes válaszért! Indulj új kalandokra, és figyeld, ahogy a Griffyd az újabb szintekre lépve egyre erősebb lesz.',
  FEATURES_CHALLENGE_FRIENDS_TITLE: [
    {
      label: 'Hívd ki',
      color: true
    },
    {
      label: 'barátaidat!'
    }
  ],
  FEATURES_CHALLENGE_FRIENDS_DESCRIPTION:
    'Vegyél részt olvasási kihívásokban és nézd meg, ki gyűjti a legtöbb pontot. Legyen a legjobb olvasó a győztes!',
  FEATURES_EARN_BADGES_TITLE: [
    { label: 'Szerezz' },
    {
      label: 'jelvényeket!',
      color: true
    }
  ],
  FEATURES_EARN_BADGES_DESCRIPTION:
    'Szerezz különböző jelvényeket a teljesítményedért és előrehaladásodért!',
  FEATURES_CREATE_COMPETITIONS_TITLE: [
    { label: 'Hozz létre' },
    {
      label: 'izgalmas',
      color: true
    },
    { label: 'olvasási versenyeket!', newLine: true }
  ],
  FEATURES_CREATE_COMPETITIONS_DESCRIPTION:
    'Ösztönözd az olvasást izgalmas versenyek létrehozásával gyermekeid vagy közösséged számára. Motiváld a fiatal olvasókat, hogy vegyenek részt szórakoztató, oktató kihívásokban!',
  FEATURES_MANAGE_AND_TRACK_TITLE: [
    { label: 'Kezeld' },
    {
      label: 'és',
      color: true
    },
    { label: 'kövesd' },
    {
      label: 'könnyedén',
      color: true
    },
    {
      label: 'a gyerekek olvasását!'
    }
  ],
  FEATURES_MANAGE_AND_TRACK_DESCRIPTION:
    'A gyerekek olvasásának nyomon követése és versenyek szervezése gyerekjáték. Könnyedén figyelemmel kísérheted minden gyermek fejlődését, teljesítményeit és kihívásait!',
  FEATURES_CONTRIBUTE_TITLE: [
    { label: 'Tölts fel kvízeket és' },
    {
      label: 'építsd',
      color: true,
      newLine: true
    },
    { label: 'a platformot!' }
  ],
  FEATURES_CONTRIBUTE_DESCRIPTION:
    'Töltsd fel saját kvízeidet, és bővítsd a közös kvízkönyvtárt! Hozzájárulásod közvetlenül javítja a fiatal olvasók tanulási élményét.',

  HIGHLIGHT_TITLE: 'Biztonságos és gyerekeknek készült',
  HIGHLIGHT_DESCRIPTION:
    'Egy gyerekbarát tér, ahol a tanulás találkozik a szórakozással. A szülők nyugodtan pihenhetnek, tudván, hogy gyermekeik biztonságos környezetben vannak.',
  DOWNLOAD_TITLE: 'Mire vársz még?',
  DOWNLOAD_DESCRIPTION:
    'A GriffyReads varázslatos világa csak egy kattintásnyira van. Iratkozz fel most és kezdd el izgalmas olvasási kalandodat. Gyűjts pontokat, neveld Griffydet és válj olvasó bajnokká!'
}

export default HU_LANDING_PAGE_CONSTANTS
